import { useState } from 'react';

const STORAGE_KEY = 'user_timezone';

export default function useTimezone() {
  const getTimezone = () => localStorage.getItem(STORAGE_KEY) || 'UTC';

  const [timezone, setTimezoneState] = useState(getTimezone);

  const setTimezone = (tz) => {
    localStorage.setItem(STORAGE_KEY, tz);
    setTimezoneState(tz);
  };

  return { timezone, setTimezone };
}
